import { useEffect, useState } from "react";
import { server, domains, locales } from "../config/index";
import Meta from "../components/Meta";
import Header from "../components/Header";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Tabs } from "antd";
import "antd/lib/tabs/style/index.css";

export default function Leaderboard({ categories, leaderboard }) {
  const [size, setSize] = useState(0);
  const { t } = useTranslation("common");
  const [recent, setRecent] = useState(null);
  const [drawerState, setDrawerState] = useState(false);
  const [tabActiveKey, setTabActiveKey] = useState("daily");
  const periods = ["daily", "weekly", "monthly", "anual", "all"];
  // TABS

  const { TabPane } = Tabs;
  const [tabsList, setTabsList] = useState([
    { tab: t("Daily"), key: "daily" },
    { tab: t("Weekly"), key: "weekly" },
    { tab: t("Monthly"), key: "monthly" },
    { tab: t("Yearly"), key: "anual" },
    { tab: t("AllTime"), key: "all" },
  ]);

  let userArray = {
    daily: [],
    weekly: [],
    monthly: [],
    anual: [],
    all: [],
  };

  for (let p = 0; p < periods.length; p++) {
    const period = periods[p];
    if (leaderboard[period] != null)
      for (let index = 0; index < leaderboard[period].length; index++) {
        const element = leaderboard[period][index];
        userArray[period].push({
          userId: element.id,
          userPlace: index + 1,
          userPhoto: element.profilePhoto,
          userName: element.username,
          userScore: element.score,
          userFacebook: element.facebookLink,
          userTwitter: element.twitterLink,
          userInstagram: element.instagramLink,
          userPinterest: element.pinterestLink,
          show: false,
        });
      }
    else userArray[period] = [];
  }
  // PLAYERS
  const [users, setUsers] = useState(userArray);
  const [topUsers, setTopUsers] = useState(users["daily"].slice(0, 3));
  useEffect(() => {
    console.log("top users", users[tabActiveKey]);
    setTopUsers(users[tabActiveKey].slice(0, 3));
  }, [tabActiveKey]);

  const handleShow = (userId) => {
    const elementsIndex = users[tabActiveKey].findIndex(
      (element) => element.userId === userId
    );
    let newArray = [...users[tabActiveKey]];
    newArray[elementsIndex] = {
      ...newArray[elementsIndex],
      show: !newArray[elementsIndex].show,
    };
    setUsers(newArray);
  };
  return (
    <>
      <Header cat={categories} />
      <div className="humoqRow leaderboardPages">
        <div className="containerNew" style={{ minHeight: size }}>
          <div className="leaderboardScope">
            <h2 className="leaderboardMainTitle">{t("Leaderboard")}</h2>
            <div className="leaderboardBestPositionBlock">
              {topUsers.map((user) => {
                return (
                  <>
                    <div
                      className={
                        user.userPlace === 1
                          ? "leaderboardBestPositionUser positionOne"
                          : "" || user.userPlace === 2
                          ? "leaderboardBestPositionUser positionTwo"
                          : "" || user.userPlace === 3
                          ? "leaderboardBestPositionUser positionThree"
                          : ""
                      }
                    >
                      <div className="leaderboardBestPositionBackDiv">
                        <div className="leaderboardBestPositionTrophyIcon">
                          <img
                            className=""
                            src={
                              user.userPlace === 1
                                ? "/trophy-1.png"
                                : "" || user.userPlace === 2
                                ? "/trophy-2.png"
                                : "" || user.userPlace === 3
                                ? "/trophy-3.png"
                                : ""
                            }
                          ></img>
                        </div>
                        <div className="leaderboardBestPositionMiddleDiv">
                          <img src="/leaderboard-character.png"></img>
                        </div>
                        <div className="leaderboardBestPositionNumberBlock">
                          <div className="leaderboardBestPositionNumber">
                            {user.userPlace}
                          </div>
                        </div>
                      </div>
                      <div className="leaderboardBestPositionPlayerName">
                        <a href="">{user.userName}</a>
                      </div>
                      <div className="leaderboardBestPositionPlayerScore">
                        {user.userScore}
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            <Tabs
              defaultActiveKey="daily"
              onChange={(key) => {
                setTabActiveKey(key);
              }}
            >
              {tabsList.map((tabInfo, index) => {
                return (
                  <TabPane tab={tabInfo.tab} key={tabInfo.key}>
                    <div className="leaderboardBlock">
                      <table className="leaderboardTable">
                        <thead>
                          <tr>
                            <th>{t("List")}</th>
                            <th>{t("Username")}</th>
                            <th>{t("TotalScore")}</th>
                            <th>{t("SocialMedia")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users[tabInfo.key].map((user) => {
                            return (
                              <tr>
                                <td
                                  className={
                                    user.userPlace === "1"
                                      ? "firstPosition"
                                      : "" || user.userPlace === "2"
                                      ? "secondPosition"
                                      : "" || user.userPlace === "3"
                                      ? "thirdPosition"
                                      : ""
                                  }
                                >
                                  {user.userPlace}
                                </td>
                                <td>
                                  <img src={user.userPhoto}></img>
                                  <a href="">{user.userName}</a>
                                </td>
                                <td>{user.userScore}</td>
                                <td>
                                  <div className="leaderboardDesktopSocialMedia">
                                    {user.userFacebook != "" ? (
                                      <a
                                        target="_blank"
                                        href={user.userFacebook}
                                      >
                                        <img src="/leaderboard-facebook.png" />
                                      </a>
                                    ) : (
                                      <></>
                                    )}
                                    {user.userTwitter != "" ? (
                                      <a
                                        target="_blank"
                                        href={user.userTwitter}
                                      >
                                        <img src="/leaderboard-twitter.png" />
                                      </a>
                                    ) : (
                                      <></>
                                    )}
                                    {user.userInstagram != "" ? (
                                      <a
                                        target="_blank"
                                        href={user.userInstagram}
                                      >
                                        <img src="/leaderboard-instagram.png" />
                                      </a>
                                    ) : (
                                      <></>
                                    )}
                                    {user.userPinterest != "" ? (
                                      <a
                                        target="_blank"
                                        href={user.userPinterest}
                                      >
                                        <img src="/leaderboard-pinterest.png" />
                                      </a>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="leaderboardMobileSocialMedia">
                                    <img
                                      className="socialMediaShareIcon"
                                      onClick={() => handleShow(user.userId)}
                                      src="/shareSocial.png"
                                    ></img>
                                    {user.show ? (
                                      <div className="socialMediaMobileBlock">
                                        <div className="triangle"></div>
                                        <span className="socialMediaItemMobile">
                                          <img src="/leaderboard-facebook.png" />
                                          <a href={user.userFacebook}>
                                            {" "}
                                            Facebook
                                          </a>
                                        </span>
                                        <span className="socialMediaItemMobile">
                                          <img src="/leaderboard-twitter.png" />
                                          <a href={user.userTwitter}>
                                            {" "}
                                            Twitter
                                          </a>
                                        </span>
                                        <span className="socialMediaItemMobile">
                                          <img src="/leaderboard-instagram.png" />{" "}
                                          <a href={user.userInstagram}>
                                            Instagram
                                          </a>
                                        </span>
                                        <span className="socialMediaItemMobile">
                                          <img src="/leaderboard-pinterest.png" />
                                          <a href={user.userPinterest}>
                                            {" "}
                                            Pinterest
                                          </a>
                                        </span>
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </TabPane>
                );
              })}
            </Tabs>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export const getServerSideProps = async (context) => {
  const domainId = locales[context.defaultLocale];
  const category_url = `${server}/api/v1/categories?domain_id=${domainId}`;
  const res_category = await fetch(category_url);
  const resultCatJSON = await res_category.json();
  const categories = resultCatJSON.data;

  const leaderboard_daily_url = `${server}/api/v1/user/leaderboard?date_range=daily`;
  const leaderboard_weekly_url = `${server}/api/v1/user/leaderboard?date_range=weekly`;
  const leaderboard_monthly_url = `${server}/api/v1/user/leaderboard?date_range=monthly`;
  const leaderboard_anual_url = `${server}/api/v1/user/leaderboard?date_range=anual`;
  const leaderboard_all_url = `${server}/api/v1/user/leaderboard?date_range=all`;
  const leaderboardDRes = await fetch(leaderboard_daily_url);
  const leaderboardWRes = await fetch(leaderboard_weekly_url);
  const leaderboardMRes = await fetch(leaderboard_monthly_url);
  const leaderboardARes = await fetch(leaderboard_anual_url);
  const leaderboardRes = await fetch(leaderboard_all_url);
  let leaderboard = {
    daily: (await leaderboardDRes.json()).data,
    weekly: (await leaderboardWRes.json()).data,
    monthly: (await leaderboardMRes.json()).data,
    anual: (await leaderboardARes.json()).data,
    all: (await leaderboardRes.json()).data,
  };
  return {
    props: {
      categories,
      leaderboard,
      ...(await serverSideTranslations(context.defaultLocale, ["common"])),
    },
  };
};
